<template>
  <tr @click="campaignClick(campaign)">
    <td :class="['sortCenter', campaignStatus, 'status_text']"><div>{{ statusText }}</div></td>
    <td v-bind:title="title" class="campaign_name_wrap">
      <div class="campaignName name">
        {{ campaign.campaign_nm }} 
      </div>
    </td>
    <td class="sortCenter date_td"><div class="fr_date_div">
      {{ campaign.campaign_fr_ymd }} </div>
    <div class="c">~</div></td>
    <td class="sortCenter date_td"><div class="to_date_div">
      {{ campaign.campaign_to_ymd }} </div></td>
    <td class="name_td fr"><div class="sortCenter name" v-bind:title="campaign.client_nm">
      <span class="responsive_text">광고주</span><span class="responsive_name">{{ campaign.client_nm }}</span></div></td>
    <td class="name_td" v-if="custKnd.a"><div class="sortCenter name" v-bind:title="campaign.agency_nm">
      <span class="responsive_text">에이전시</span><span class="responsive_name">{{ campaign.agency_nm }}</span></div></td>
    <td class="name_td" v-if="custKnd.l"><div class="sortCenter name" v-bind:title="campaign.lab_cust_nm">
      <span class="responsive_text">랩사</span><span class="responsive_name">{{ campaign.lab_cust_nm }}</span></div></td>
  </tr>
</template>
  
<script>
  import { getStatusClass, statusText } from '@/assets/func'

  export default {
    name: 'result',
    data () {
      return {
        title: this.campaign.campaign_nm
      }
    },
    props: {
      // data props
      campaign: Object,
      custKnd: Object,
      status: Array,
      // function props
      campaignClick: Function
    },
    computed: {
      campaignStatus () {
        return getStatusClass(this.campaign.status)
      },
      statusText () {
        return statusText(this.campaign.status)
      }
    }
  }
</script>

<style scoped>
  tr:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.04) !important;
  }
  .campaignName.name {
    text-align: left;
  }

  td {
    min-width: 80px;
  }
  .name_td {
    max-width: 80px;
  }
  .name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .campaign_name_wrap {
    max-width: 200px;
    padding-left: 10px;
  }
  .sortCenter {
    text-align: center
  }
  .sortCenter.name, .campaignName.name {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .date_td, .status_text {
    max-width: 85px;
    min-width: 85px;
    width: 85px;
  }
  .responsive_text {
    display: none;
  }
  .text-blue {
    color: #0000ff
  }
  .text-red {
    color: #ff0000
  }
  .text-green {
    color: #00a000
  }
  .c {
    display: none;
  }

  @media screen and (max-width: 800px) {
    tr {
      border-bottom: 1px solid #eaeaea;
    }
    .status_text div {
      height: 25px;
      line-height: 25px;
      border-bottom: 1px solid #d1dce3
    }
    .fr_date_div {
      position: absolute;
      left: -60px;
      top: 23px;
    }
    .c {
      display: block;
      position: absolute;
      left: -34px;
      top: 43px;
    }
    .to_date_div {
      position: absolute;
      left: calc(-100% - 60px);
      top: 62px;
    }
    .sortCenter.name {
      display: flex;
      width: calc(100% - 45px);
      justify-content: space-between;
      padding-left: 15px !important;
      padding-right: 30px !important;
    }
    .responsive_text {
      display: block;
    }
    .campaignName.name {
      max-width: 500px;
      text-align: center;
    }
    .name_td.fr {
      margin-top: -18px;
    }
    td {
      display: block;
      width: 100%;
      max-width: 100% !important;
      min-width: 0;
      height: 20px;
      padding: 0;
      border: none;
    }
    td div {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
    .status_text {
      vertical-align: top;
      height: 90px;
      display: table-cell;
      width: 66px !important;
      min-width: 66px !important;
    }
    .campaign_name_wrap {
      padding-left: 0;
      height: 25px;
      line-height: 25px;
      vertical-align: middle;
      border-bottom: 1px solid #d1dce3;
      font-weight: 500;
    }
    .date_td {
      position: relative;
      margin-top: -45px;
      display: inline-block;
      width: 40%;
    }
  }
  @media screen and (max-width: 600px) {
    .campaignName.name {
      max-width: 400px;
    }
  }
  @media screen and (max-width: 500px) {
    .campaignName.name {
      max-width: 320px;
    }
  }
  @media screen and (max-width: 400px) {
    .campaignName.name {
      max-width: 280px;
    }
    .sortCenter.name {
      padding-right: 0 !important;
      padding-left: 0 !important;
      max-width: calc(100% - 20px);
          width: calc(100% - 30px);
    }
  }
  @media screen and (max-width: 360px) {
    .campaignName.name {
      max-width: 230px;
    }
    .responsive_name {
      padding-left: 10px;
      max-width: 180px;
    }
  }
</style>



// WEBPACK FOOTER //
// Result.vue?738fe6de